import { Stack, styled, useTheme } from '@mui/material'
import { UserIcon } from '@phosphor-icons/react'
import { Button, Footer, FullPageEmptyState2, getUserSettingsModalUrl, TOOLBAR_HEIGHT, Typography } from 'ComponentLibrary'
import { STATIC_APP_PATHS } from 'ClientPortal/src/router/constants'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function Welcome() {
    const theme = useTheme()
    const navigate = useNavigate()
    const { t } = useTranslation('pages', { keyPrefix: 'welcomePage' })

    return (
        <ErrorPageContainer>
            <TextStack direction="column" spacing={theme.spacing(4)}>
                <Typography variant="headline1">{t('title')}</Typography>
                <Typography variant="bodyTextLarge">{t('description')}</Typography>
                <Stack direction="row" gap={theme.spacing(6)} sx={{ paddingTop: theme.spacing(8) }}>
                    <Button
                        startIcon={<UserIcon />}
                        label={t('cta')}
                        onClick={() =>
                            navigate(
                                getUserSettingsModalUrl({
                                    pathname: STATIC_APP_PATHS.orderListPage,
                                    search: '',
                                    tab: 'profile',
                                })
                            )
                        }
                    />
                </Stack>
            </TextStack>
            <StyledFullPageEmptyState1Image />
            <Stack direction="row" position="absolute" bottom={0} width="100%" zIndex="2" sx={{ backgroundColor: theme.palette.white }}>
                <Footer />
            </Stack>
        </ErrorPageContainer>
    )
}

const ErrorPageContainer = styled('div')`
    width: 100vw;
    height: calc(calc(100vh - ${TOOLBAR_HEIGHT}) - 1px);
    position: absolute;
    left: 0;
    top: ${TOOLBAR_HEIGHT};
    overflow: hidden;
`

const TextStack = styled(Stack)(({ theme }) => ({
    top: '16%',
    left: '16%',
    position: 'absolute',
    maxWidth: '480px',
    padding: theme.spacing(4),
    zIndex: 2,
}))

const StyledFullPageEmptyState1Image = styled(FullPageEmptyState2)(() => ({
    position: 'absolute',
    right: '-35%',
    bottom: '-30%',
    width: '100%',
    height: '100%',
    zIndex: 1,
}))
